likes_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

    },

    addLike: function(id){

        var self = this;
        var value = feedbackData.data[id];

        $.ajax({
          type: "POST",
          url: properties.likesURL,
          data: {
            'sid': id,
            created: 'date'
          },
          success: function(json) {
            value.likes = parseInt(value.likes) + 1;
            home_handler.addLS(id);

            //update view content
            self.getLikes(id);

          },
          error: function(xhr, textStatus, errorThrown) {
            console.log(textStatus);
          }
        });
    },

    likeBtn: function(comment) {
        if (comment in properties.pvlk){
          return '';
        }
        else {
          return ' / <a class="add-like" href="#">Like This</a>'
        }
    },

    fixedLikes: function(likes) {
        if (likes == 1) {
            return "1 person likes this.";
        } else if (likes > 1) {
            return likes + " people like this.";
        }
        else  if (likes == 0){
          return "No one has liked this."
        }
    },

    getLikes: function(id){
        var self = this;

        if (id){
            var likesNum = feedbackData.data[id].likes;
            $('.view-like').html(self.fixedLikes(likesNum)).removeClass('hidden');
            $('.add-like').click(function(event) {
                self.addLike(id);
                event.preventDefault();
            });
        }
    },

    events: function() {
        var self = this;
        
    }
}